export enum ActionTargetsEnum {
  REPAIRER = "REPAIRER",
  OPERATOR = "OPERATOR",
}

export const ActionTargets = {
  REPAIRER: { id: "1", name: ActionTargetsEnum.REPAIRER },
  OPERATOR: { id: "2", name: ActionTargetsEnum.OPERATOR },
};
